import React from 'react'
import { ApplicationForm, Footer, Footer2 } from '../Componenets'
import Navbar2 from '../Componenets/navbar/Navbar2'


const Apply = () => {
  return (
    <div>
      <div className="pt-28"> {/* Adjust pt-28 as needed to match your navbar height */}
        <ApplicationForm />
      </div>
      <Footer2 />
    </div>
  )
}

export default Apply